import Image from "next/image";
import styled from "styled-components";
import SecondaryNav from "@/components/UI/attorney-secondary-nav/secondaryNav";
import AttorneyBanner from "@/components/UI/attorney-banner/attorneyBanner";
import AttorneyDropDown from "@/components/mobile-dropdown-menu/attorneyDropDown";
import banner from "../../../../public/images/Dally_Banner.png";

export default function Dally() {
  return (
    <Container>
      <AttorneyBanner
        src={banner}
        alt="mally banner image"
        maxWidth={"512px"}
        top={"12px"}
        name={"LORI E. DALLY"}
        email={"LORI@TEXFAMILYLAWYER.COM"}
        priority={true}
      />
      <div className="center-wrapper">
        <Content className="item">
          <p>
            As a legal assistant during law school, I was exposed to family law
            and immediately knew that’s the type of law I wanted to practice.
            Family Law gives me the ability to connect with people on a personal
            level, help solve problems and lead people through one of the
            toughest struggles of their lives. Whether it’s in the courtroom or
            in the office, I enjoy being able to effectively and zealously
            advocate for my clients and to change their lives for the better.
            <br />
            <br /> I grew up in Coppell, Texas and attended Ursuline Academy in
            Dallas. I am a graduate Texas Christian University and Texas
            Wesleyan School of Law (now Texas A&M School of Law). My husband and
            I are avid TCU fans and never miss a game. When we are not cheering
            on the Horned Frogs, you can usually find me spending quality time
            with my husband, three daughters, two dogs and two cats.
          </p>
          <span />
          <b>Education</b>
          <p>
            Texas Wesleyan University School of Law - Fort Worth, Texas (Now
            known as Texas A&M University School of Law) Juris Doctorate, 2010 -
            Graduated in the top 13% of class Dean’s List - Every semester Phi
            Delta Phi Law Review
            <br />
            <br />
            Texas Christian University - Fort Worth, Texas Bachelor of Science,
            Environmental Science, 2007 Delta Gamma Fraternity
          </p>
          <span />
          <b>Experience</b>
          <p>
            Seltzer Dally & Webb, PLLC - Fort Worth, Texas
            <br />
            Attorney and Counselor at Law
            <br />
            <br />
            Seltzer & Dally, PLLC - Fort Worth, Texas
            <br />
            Attorney and Counselor at Law
            <br />
            <br />
            Beal Law Firm - Southlake, Texas
            <br />
            Senior Associate Attorney
            <br />
            <br />
            Antonio Olvera, Jr. and Associates - Dallas, Texas
            <br />
            Associate Attorney
          </p>
          <span />
          <b>Memberships</b>
          <p>
            Licensed to practice before the Supreme Court of the United States
            <br />
            The College of the State Bar of Texas <br />
            Tarrant County Bar Association <br />
            Tarrant County Family Law Bar Association <br />
            State Bar of Texas <br />
            Family Law Section, State Bar of Texas <br />
            Texas Academy of Family Law Specialists - Member
          </p>
          <span />
          <b>Awards</b>
          <p>
            2019-2025 Texas Rising Stars, Super Lawyers <br />
            2017-2025 Fort Worth Magazine’s Top Attorney - Family Law <br />
            2021 Top Women Attorney in Texas 2020, <em>Texas Monthly</em> <br />
            2021 Top Young Attorney in Texas, <em>Texas Monthly</em> <br />
            2016-2021 AVVO Client’s Choice <br />
            2020 Top Women Attorney in Texas Rising Stars,{" "}
            <em>Texas Monthly</em> <br />
            2020 Texas Outstanding Young Attorney, <em>Texas Monthly</em> <br />
            2019 Top Attorney - Texas Outstanding Young Women Lawyers,{" "}
            <em>Texas Monthly</em> <br />
            2019 Top Attorney - Texas Outstanding Young Lawyers,{" "}
            <em>Texas Monthly</em>
          </p>
          <span />
          <b>Community Involvement</b>
          <p>
            Fort Worth Pregnancy Center, Past President
            <br />
            Delta Gamma Fraternity - TCU, previous House Management Advisor
          </p>
          <span />
          <b>Publications</b>
          <p>
            SETTING YOUR CLIENT UP FOR SUCCESS: FROM FILING THE CASE TO
            TEMPORARY ORDERS AND BEYOND
          </p>
        </Content>
        <div className="side-nav">
          <SecondaryNav />
        </div>
        <span className="mobile-dropdown">
          <AttorneyDropDown title={"Attorneys"} />
        </span>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .center-wrapper {
    width: 100%;
    max-width: 1230px;
    margin: 0 auto;
    padding: 4rem 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .side-nav {
    margin-left: auto;
    display: inline-flex;
  }

  .mobile-dropdown {
    display: none;
  }

  @media (max-width: 1300px) {
    .center-wrapper {
      padding: 2rem;
    }
    .item {
      order: 2;
    }
    .side-nav {
      display: none;
    }
    .mobile-dropdown {
      width: 100%;
      max-width: 492px;
      height: 44px;
      box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);
      display: block;
      margin: 0 auto 2rem auto;
      order: 1;
    }
  }
`;

const Content = styled.div`
  display: inline-block;
  width: 100%;
  max-width: 752px;
  & b {
    font-weight: 700;
    display: block;
  }
  & p {
    margin-top: 0.5rem;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    display: inline-block;
  }

  & span {
    display: block;
    width: 100%;
    max-width: 488px;
    border-top: 1px solid #67318d;
    margin: 2rem 0;
  }
`;
